import { Routes, Route } from 'react-router-dom';

// Protected Routes
// @ref https://www.robinwieruch.de/react-router-private-routes/

import './App.css';
import RegisterPage from './pages/common-pages/register.page';
import SignInPage from './pages/common-pages/sign-in.page';
import AdminDashboardLayout from './components/layout/admin-dashboard-layout.component';
import RequireAuth from './components/require-auth/require-auth.component';
import Unauthorized from './pages/common-pages/unauthorizes.page';
import MissingPage from './pages/common-pages/missing.page';
import PersistentLogin from './components/persistent-login/persistent-login.component';
import AdminRoutes from './routes/admin.routes';
import { MerchantOnboardingStatus } from './enums/merchant-onboarding-status';
import OnboardingLayout from './components/layout/onboarding-layout.component';
import { Roles } from './enums/roles-enum';
import MerchantBranchesDashboardLayout from './components/layout/merchant-branch-dashboard-layout.component';
import { AccountTypes } from './enums/account-type';
import UnauthorizedLayout from './components/layout/unauthorized-layout.component';
import MerchantOnboardingRoutes from './routes/merchant-onboarding.routes';
import PartnerRoutes from './routes/partner.routes';
import PartnerDashboardLayout from './components/layout/partner-dashboard-layout.component';
import ResellerDashboardLayout from './components/layout/reseller-dashboard-layout.component';
import ResellerRoutes from './routes/reseller.routes';
import MerchantDashboardLayout from './components/layout/merchant-dashboard-layout.component';
import MerchantBranchRoutes from './routes/merchant-branch.routes';
import MerchantRoutes from './routes/merchant.routes';
import useAuth from './hooks/useAuth';
import { Ad } from 'tabler-icons-react';
import SettlementDashboardLayout from './components/layout/settlement-dashboard-layout.component';
import ForgetPasswordPage from './pages/public-pages/forget-password/forget-password.page';
import ResetPasswordPage from './pages/public-pages/reset-password/reset-password.page';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import CheckerDashboardLayout from './components/layout/checker-dashboard-layout.component';

function App() {
  const { auth } = useAuth();
  return (
    <Routes>
      {/* protected routes */}
      <Route element={<PersistentLogin />}>
        <Route
          element={
            <RequireAuth
              allowedRoles={[]}
              allowedAccountType={[]}
              allowedOnboardingStatus={[]}
            />
          }
        >
          <Route path='login' element={<SignInPage />} />
          <Route path='register' element={<RegisterPage />} />
          <Route path='forgot-password' element={<ForgetPasswordPage />} />
          <Route path='reset-password' element={<ResetPasswordPage />} />
        </Route>
        {/* Route to admin pages */}
        <Route
          element={
            auth?.role === Roles.ADMINISTRATOR ? (
              <AdminDashboardLayout />
            ) : auth?.role === Roles.SETTLEMENT ? (
              <SettlementDashboardLayout />
            ) : (
              <CheckerDashboardLayout />
            )
          }
        >
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  Roles.ADMINISTRATOR,
                  Roles.SETTLEMENT,
                  Roles.CHECKER,
                ]}
                allowedAccountType={Object.values(AccountTypes)}
                allowedOnboardingStatus={Object.values(
                  MerchantOnboardingStatus
                )}
              />
            }
          >
            <Route path='admin/*' element={<AdminRoutes />} />
          </Route>
        </Route>
        {/* Route to partner routes */}
        <Route element={<PartnerDashboardLayout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[Roles.PARTNER]}
                allowedAccountType={[AccountTypes.PARTNER]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.APPROVED]}
              />
            }
          >
            <Route path='partner/*' element={<PartnerRoutes />} />
          </Route>
        </Route>
        {/* Route to reseller routes */}
        <Route element={<ResellerDashboardLayout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[Roles.RESELLER]}
                allowedAccountType={[AccountTypes.RESELLER]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.APPROVED]}
              />
            }
          >
            <Route path='reseller/*' element={<ResellerRoutes />} />
          </Route>
        </Route>
        {/* Route to merchant routes */}
        <Route element={<MerchantDashboardLayout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[Roles.MERCHANT]}
                allowedAccountType={[AccountTypes.MERCHANT]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.APPROVED]}
              />
            }
          >
            <Route path='merchant/*' element={<MerchantRoutes />} />
          </Route>
        </Route>
        {/* Route to merchant branch routes */}
        <Route element={<MerchantBranchesDashboardLayout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[Roles.MERCHANT_BRANCH]}
                allowedAccountType={[AccountTypes.MERCHANT_BRANCH]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.APPROVED]}
              />
            }
          >
            <Route path='branches/*' element={<MerchantBranchRoutes />} />
          </Route>
        </Route>
        {/* Route to merchant onboarding */}
        <Route element={<OnboardingLayout />}>
          <Route path='onboarding/*' element={<MerchantOnboardingRoutes />} />
        </Route>

        {/* Route to account verification pending page */}
        {/* <Route element={<OnboardingLayout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  Roles.MERCHANT,
                  Roles.PARTNER,
                  Roles.RESELLER,
                  Roles.MERCHANT_BRANCH,
                ]}
                allowedAccountType={[
                  AccountTypes.MERCHANT_BRANCH,
                  AccountTypes.PARTNER,
                  AccountTypes.RESELLER,
                  AccountTypes.MERCHANT,
                ]}
                allowedOnboardingStatus={[MerchantOnboardingStatus.NO_RECORD]}
              />
            }
          >
            <Route
              path='account-verification'
              element={<AccountVerificationPendingPage />}
            />
          </Route>
        </Route> */}
        {/* This route is just to keep the logo in the header/navbar
            work */}
        <Route
          element={
            <RequireAuth
              allowedRoles={[]}
              allowedAccountType={[]}
              allowedOnboardingStatus={[]}
            />
          }
        >
          <Route path='dashboard/*' />
        </Route>
        {/* Unauthorized page */}
        <Route element={<UnauthorizedLayout />}>
          <Route path='unauthorized' element={<Unauthorized />} />
        </Route>

        {/* public routes */}
        {/* Password reset*/}
        <Route>
          <Route path='forgot-password' element={<ForgetPasswordPage />} />
          <Route path='reset-password' element={<ResetPasswordPage />} />
        </Route>

        {/* Missing page route */}
        <Route element={<UnauthorizedLayout />}>
          <Route path='*' element={<MissingPage />} />
        </Route>
      </Route>

      {/* public routes */}

      {/* Route to home page */}
      {/* TODO set proper page for index */}
      <Route
        element={
          <RequireAuth
            allowedRoles={Object.values(Roles)}
            allowedAccountType={Object.values(AccountTypes)}
            allowedOnboardingStatus={Object.values(MerchantOnboardingStatus)}
          />
        }
      >
        <Route
          path='/'
          element={<p>Work in progress... This should be the landing page</p>}
        />
      </Route>
    </Routes>
  );
}

export default App;
